import { useEffect } from "react";

const initializedGtmTags = new Set<string>();
const initializedGa4Ids = new Set<string>();

const injectGtm = (gtmTag: string): void => {
  const scripts = Array.from(document.head.getElementsByTagName("script"));
  const alreadyLoaded = scripts.some((s) => s.src.includes(`gtm.js?id=${gtmTag}`));
  if (alreadyLoaded) return;

  const script = document.createElement("script");
  script.dataset.tellescopeGtm = gtmTag;
  script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;j.dataset.tellescopeGtm=i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',${JSON.stringify(
    gtmTag
  )});`;
  document.head.appendChild(script);
};

const injectGa4 = (measurementId: string): void => {
  const tagScript = document.createElement("script");
  tagScript.async = true;
  tagScript.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  tagScript.dataset.tellescopeGa4 = measurementId;
  document.head.appendChild(tagScript);

  const inline = document.createElement("script");
  inline.dataset.tellescopeGa4 = measurementId;
  inline.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config',${JSON.stringify(
    measurementId
  )});`;
  document.head.appendChild(inline);
};

/**
 * Loads a form's configured GTM and/or GA4 tags.
 *
 * Both loaders are page-scoped and install global state on `window` that removing the injected
 * `<script>` would not undo, so a tag is injected at most once per page load and is deliberately
 * left in place on unmount — the wizard remounts whenever its dialog reopens, and re-injecting
 * would re-fire `gtag('config', …)` and double-count pageviews.
 */
export const useFormAnalytics = (gtmTag: string | undefined, ga4MeasurementId: string | undefined) => {
  // Justified, injecting gtm script
  useEffect(() => {
    if (!gtmTag) return;
    if (initializedGtmTags.has(gtmTag)) return;
    initializedGtmTags.add(gtmTag);

    injectGtm(gtmTag);
  }, [gtmTag]);

  // Justified, injecting ga4 script
  useEffect(() => {
    if (!ga4MeasurementId) return;
    if (initializedGa4Ids.has(ga4MeasurementId)) return;
    initializedGa4Ids.add(ga4MeasurementId);

    injectGa4(ga4MeasurementId);
  }, [ga4MeasurementId]);
};
